export const STATUS_LABEL = {
  UPLOADED: 'Uploaded',
  CONVERTING: 'Converting…',
  CONVERTED: 'Converted',
  COMBINED: 'Combined',
  CONVERT_FAILED: 'Convert failed',
  SUGGESTED: 'Suggested',
  REDACTED: 'Redacted',
  PROCESSING: 'Preparing…'
}

export const STATUS_TONE = {
  UPLOADED: 'raw',
  CONVERTING: 'loading',
  CONVERTED: 'ready',
  COMBINED: 'ready',
  CONVERT_FAILED: 'failed',
  SUGGESTED: 'done',
  REDACTED: 'applied',
  PROCESSING: 'loading'
}

export const STATUS_ICON = {
  UPLOADED: 'document',
  CONVERTING: 'spinner',
  CONVERTED: 'check',
  COMBINED: 'merge',
  CONVERT_FAILED: 'alert',
  SUGGESTED: 'question',
  REDACTED: 'shield',
  PROCESSING: 'spinner'
}

export const pdfLike = f => !!f.pdfObjectKey
export const convertible = f => !f.pdfObjectKey && f.kind !== 'COMBINED' && f.status !== 'CONVERTING'

export const displayKind = f => {
  if (f?.pdfObjectKey) return 'PDF'
  if (f?.kind === 'COMBINED') return 'PDF'
  return f?.kind || 'FILE'
}

export const originalDisplayKind = f => (f?.kind === 'COMBINED' ? 'PDF' : f?.kind || 'FILE')

export const FILE_STATUSES = ['UPLOADED', 'CONVERTING', 'CONVERTED', 'COMBINED', 'CONVERT_FAILED', 'SUGGESTED', 'REDACTED']
export const FILTER_STATUSES = [...FILE_STATUSES, 'PROCESSING']

export const STATUS_RANK = {
  UPLOADED: 0,
  CONVERTING: 1,
  CONVERT_FAILED: 2,
  CONVERTED: 3,
  COMBINED: 4,
  PROCESSING: 5,
  SUGGESTED: 6,
  REDACTED: 7
}

export const viewStatus = (file, running) => (running ? 'PROCESSING' : file.status)
